const data = {
  name: "Sa-Yoor Headley",
  address: "Guyana",
  email: "mailto:sai.h152015@gmail.com",
  websites: {
    portfolio: "https://sa-yoorheadley.github.io/portfolio/",
    github: "https://github.com/Sa-YoorHeadley",
    linkedIn: "https://www.linkedin.com/in/sa-yoor-headley/",
  },
  programmingLanguagesFrameworks: {
    frontend: [
      "React",
      "TypeScript",
      "JavaScript",
      "SCSS",
      "Tailwind",
      "CSS",
      "HTML",
    ],
    backend: ["Node JS", "Express", "Go", "Java"],
    database: ["MongoDB", "SQL"],
    other: ["Google Apps Script", "Python", "C", "Pascal"],
  },
  tools: [
    "Visual Studio Code",
    "Git",
    "Github",
    "Figma",
    "Photoshop",
    "Google Docs",
    "Google Sheets",
  ],
  skills: [
    "Responsive Web Design",
    "MVC Pattern",
    "REST API Design",
    "Analytic and Creative Problem Solving",
    "Computer Networking",
    "Computer Repair",
    "Customer Service Skills",
    "Microsoft Office Suite",
    "Quickbooks Point of Sale System",
  ],
  profile: `Equipped with a promising skill-set. Passion for problem solving and creative solutions. Able to effectively self-manage during independent projects, as well as collaborate as part of a productive team.`,
  employment: [
    {
      title: `Junior Full Stack Engineer`,
      employer: `HRTM Incorporated`,
      location: `Hybrid`,
      duration: {
        startDate: "Nov-2023",
        endDate: "Present",
      },
      workedOn: [
        `Design and build new and previously existing full stack applications using a variety of languages.`,
        `Creating custom reports using BIRT.`,
      ],
      toolsUsed: [
        `Go`,
        `Java`,
        `Typescript`,
        `React`,
        `Tailwind CSS`,
        `SQL`,
        `Figma`,
        `Docker`,
      ],

      responsibilities: [
        `Writing new computer codes to fit existing software, apps or programs`,
        `Sourcing existing code from open code libraries or databases developed by a company`,
        `Thoroughly testing computer programs and recommending updates or changes before release`,
        `Training new users to use updated programs or hardware`,
        `Debugging computer programs experiencing faults and glitches`,
        `Developing security systems and procedures to protect users from hacks and programs from viruses`,
        `Keeping up-to-date on new developments and advances in coding and software development`,
        `Developing front end website architecture`,
        `Designing user interactions on web pages`,
        `Developing back-end website applications`,
        `Creating servers and databases for functionality`,
        `Ensuring responsiveness of applications`,
        `Working alongside graphic designers for web design features`,
        `Seeing through a project from conception to finished product`,
        `Designing and developing APIs`,
        `Meeting both technical and consumer needs`,
        `Staying abreast of developments in web applications and programming languages`,
      ],
    },
    {
      title: `Full Stack Developer`,
      employer: `Xploy Incorporated`,
      location: `Hybrid`,
      duration: {
        startDate: "Nov-2022",
        endDate: "Nov-2023",
      },
      workedOn: [
        `Built multiple full stack applications using React, Tailwind, Node JS, Express, MongoDB SQL.`,
      ],
      toolsUsed: [
        `Javascript`,
        `React`,
        `Tailwind CSS`,
        `SASS/CSS`,
        `Node`,
        `Express`,
        `SQL`,
        `MongoDB`,
        `HTML`,
      ],
      responsibilities: [
        `Writing new computer codes to fit existing software, apps or programs`,
        `Sourcing existing code from open code libraries or databases developed by a company`,
        `Thoroughly testing computer programs and recommending updates or changes before release`,
        `Training new users to use updated programs or hardware`,
        `Debugging computer programs experiencing faults and glitches`,
        `Developing security systems and procedures to protect users from hacks and programs from viruses`,
        `Keeping up-to-date on new developments and advances in coding and software development`,
        `Developing front end website architecture`,
        `Designing user interactions on web pages`,
        `Developing back-end website applications`,
        `Creating servers and databases for functionality`,
        `Ensuring cross-platform optimization for mobile phones`,
        `Ensuring responsiveness of applications`,
        `Working alongside graphic designers for web design features`,
        `Seeing through a project from conception to finished product`,
        `Designing and developing APIs`,
        `Meeting both technical and consumer needs`,
        `Staying abreast of developments in web applications and programming languages`,
      ],
    },
    {
      title: `Programmer`,
      employer: `Express International Inc. (Bayard Department)`,
      location: `Remote`,
      duration: {
        startDate: "Dec-2021",
        endDate: "Aug-2022",
      },
      workedOn: [
        `Built a full stack candidate management application using React, SCSS, Node JS, Express and SQL.`,
        "Built, refactored and debugged multiple scripts using Google Apps Script that were used to manage candidate information in Google Sheets, Docs and Forms.",
      ],
      toolsUsed: [
        `Google Apps Script`,
        `Javascript`,
        `React`,
        `SASS/CSS`,
        `Node`,
        `Express`,
        `SQL`,
        `HTML`,
      ],
      responsibilities: [
        `Writing new computer codes to fit existing software, apps or programs`,
        `Sourcing existing code from open code libraries or databases developed by a company`,
        `Thoroughly testing computer programs and recommending updates or changes before release`,
        `Training new users to use updated programs or hardware`,
        `Debugging computer programs experiencing faults and glitches`,
        `Developing security systems and procedures to protect users from hacks and programs from viruses`,
        `Keeping up-to-date on new developments and advances in coding and software development`,
        `Ensuring that all code and software complies with data protection laws and security regulations`,
      ],
    },
    {
      title: `Cashier`,
      employer: `Linden Utility Services Co-Op Society, Ltd.`,
      location: `Linden, Guyana`,
      duration: {
        startDate: "Nov-2020",
        endDate: "Dec-2020",
      },
      toolsUsed: [`Quickbooks POS`, `Microsoft Excel`],
      responsibilities: [
        `Handle cash, credit, and check transactions with customers`,
        `Ensure pricing is correct`,
        `Issue change, receipts, and refunds`,
        `Count money in cash drawers at the beginning and end of shifts to`,
        `ensure that amounts are correct and that there is adequate change`,
        `Resolve customer complaints, guide them and provide relevant information`,
        `Keep reports/records of transactions`,
        `Process returns`,
        `Provided assistance as Help Desk Tech Support, Acting MIS Officer and Graphic Designer`,
      ],
    },
    {
      title: `Management Information Systems Officer (Fixed Term Contract)`,
      employer: `Linden Utility Services Co-Op Society, Ltd.`,
      location: `Linden, Guyana`,
      duration: {
        startDate: "Nov-2019",
        endDate: "Sep-2021",
      },
      toolsUsed: [`Windows Server 2016`, `Microsoft Excel`, `Microsoft Word`],
      responsibilities: [
        `Develop and maintain broad knowledge of the company's technology requirements and needs`,
        `Manage process improvements for increased efficiency`,
        `Plan and manage software and hardware installations and upgrades`,
        `Perform periodic maintenance and servicing of computer systems, printer, and networking equipment`,
        `Monitor performance regularly to avoid unplanned outages and downtimes`,
        `Provide help-desk support for OS issues, network problems, and software upgrades, etc.`,
        `Track and monitor the security of hardware and software systems`,
      ],
    },
    {
      title: `Graphic and Sales Clerk (Fixed Term Contract)`,
      employer: `Linden Utility Services Co-Op Society, Ltd.`,
      location: `Linden, Guyana`,
      duration: {
        startDate: "Oct-2019",
        endDate: "Oct-2019",
      },
      toolsUsed: [`Microsoft Excel`, `Microsoft Word`],
      responsibilities: [
        `Greet and assist customers`,
        `Upselling items to customers based on the items they have chosen`,
        `Replace merchandise on shelves and keep track of items in storage`,
        `Arrange special sales and clearance items at the front of the store for maximum visibility`,
        `Provide customers with genuine guidance and support`,
      ],
    },
    {
      title: `Coding Instructor (Summer School)`,
      employer: `Ministry of Public Telecommunication (Guyana)`,
      location: `Linden, Guyana`,
      duration: {
        startDate: "Aug 2018",
        endDate: "Sep 2019",
      },
      toolsUsed: [`HTML`, `CSS`, `Python`, `Java`, `SQL`, `Microbit`],
      responsibilities: [
        `Teaching coding languages (HTML, CSS, Python, Java, SQL, and Microbit) to children aged 5 to 18`,
        `Work along with another Instructor to manage student learning and ensure a positive experience for students and families`,
        `Design and use a curriculum to teach and lead children in their lessons and projects`,
        `Come up with creative ideas that children can implement in their projects`,
        `Be able to respond to parent questions about their child's progress`,
        `Assessing a student's level of interest in the programme`,
      ],
    },
  ],
  education: [
    {
      name: `Diploma in Computer Science`,
      institute: `Linden Technical Institute `,
      location: `Linden, Guyana`,
      year: `2019`,
      duration: {
        startDate: "2017",
        endDate: "2019",
      },
      merits: [
        `Graduated with Credit`,
        `2nd Best Graduating Student in Linden Technical Institute`,
        `Best Graduating Student of Diploma in Computer Science for 2019`,
        `Student Guild President`,
      ],

      subjects: [
        { name: `English Language`, grade: `B-` },
        { name: `Management`, grade: `B-` },
        { name: `Mathematics`, grade: `B- ` },
        { name: `Statistics`, grade: `A` },
        { name: `Software`, grade: `B` },
        { name: `Hardware (Phase Test)`, grade: `A+` },
        { name: `Programming`, grade: `A-` },
      ],
    },
    {
      name: `CSEC`,
      institute: `Christianburg Wismar Secondary School`,
      location: `Linden, Guyana`,
      year: `2017`,
      duration: {
        startDate: "2013",
        endDate: "2017",
      },
      merits: [
        `2nd Best Graduating Student in Region 10`,
        `Best Graduating Student of 5 Tech in 2017`,
      ],
      subjects: [
        { name: `EDPM`, grade: `1` },
        { name: `English A`, grade: `2` },
        { name: `Geography`, grade: `2` },
        { name: `Information Technology`, grade: `1` },
        { name: `Industrial Technology (Building)`, grade: `1` },
        { name: `Industrial Technology (Electrical)`, grade: `1` },
        { name: `Industrial Technology (Mechanical)`, grade: `2` },
        { name: `Integrated Science`, grade: `2` },
        { name: `Mathematics`, grade: `1` },
        { name: `P.E. and Sport`, grade: `1` },
        { name: `Physics`, grade: `3` },
        { name: `Technical Drawing`, grade: `1` },
      ],
    },
  ],
  certificates: [
    {
      name: `Backend Development and APIs`,
      institute: `freeCodeCamp`,
      location: `Online`,
      year: `2023`,
    },
    {
      name: `Responsive Web Design`,
      institute: `freeCodeCamp`,
      location: `Online`,
      year: `2021`,
    },
    {
      name: `Introduction and Delivery of Competency Based Training`,
      institute: `Council for Technical & Vocational Education and Training`,
      location: `Linden, Guyana`,
      year: `2019`,
    },
    {
      name: `Customer Care`,
      institute: `Linden Technical Institute`,
      location: `Linden, Guyana`,
      year: `2019`,
    },
    {
      name: `Micro Enterprising`,
      institute: `Linden Technical Institute`,
      location: `Linden, Guyana`,
      year: `2018`,
    },
  ],
  internships: [
    {
      title: `Assistant Computer and Network Technician`,
      employer: `Linden Hospital Complex`,
      location: `Linden, Guyana`,
      duration: {
        startDate: "Jul 2017",
        endDate: "Aug 2012",
      },
      toolsUsed: [`Networking Tool Kit`],
      responsibilities: [
        `Design and install well-functioning computer networks, connections, and cabling`,
        `Perform troubleshooting to system failures and fix them to ensure long term efficiency of network`,
        `Inspect network infrastructure and fix major or minor problems/bugs`,
        `Organize and schedule upgrades and maintenance without interrupting workflow`,
        `Provide help-desk support to employees`,
      ],
    },
  ],
};
export default data;
